<template>
    <main>
        <Background :image="backgroundImage" :setBackgroundImage="setBackgroundImage"/>

        <Title
                title="Za profilno sliko je lahko kdorkoli!"
                background="rgba(245, 164, 199, 0.8)"
                v-observe-visibility="observeTitle"/>

        <Floater :isVisible="showFloater"/>

        <Facts/>

        <Risk background="rgba(0, 0, 0, 0.8)">
            <p>Kriminalci svoje žrtve največkrat iščejo na Facebooku ali Instagramu, kjer postavijo lažen profil z
                lepimi slikami. Pošljejo prošnjo za prijateljstvo, pričnejo pogovor in razkrijejo svojo tragično
                življenjsko zgodbo – so osamljeni marinci, ovdoveli zdravniki z majhnimi otroki, človekoljubni
                delavci. Ko vzpostavijo zaupen odnos, pričnejo s prošnjami za denar.</p>

            <p class="highlight text-yellow">Ko je denar nakazan, sledijo vedno nove prošnje, dokler žrtev ne ugotovi,
                da je vse popolna laž.</p>

            <p class="mt-3 mt-lg-5">Druga pogosta spletna prevara, ki temelji na čustveni manipulaciji, je izsiljevanje
                z intimnimi posnetki ali sextortion. Ponovno se začne s kontaktom na Facebooku, ko neznanka z izzivalno
                profilno sliko pošlje prošnjo za prijateljstvo in prične pogovor. Z žrtvijo začne koketirati in jo
                prepričuje, da se sleče pred spletno kamero.</p>

            <p class="highlight text-yellow">Ko prejme intimni posnetek ali fotografije, začne izsiljevati, da bo
                posnetek poslala vsem prijateljem in družini, če ji ne bo nakazala denarja. Tukaj govorimo o zelo
                velikih vsotah, tudi več tisoč evrov!</p>
        </Risk>

        <Actions background="rgba(245, 164, 199, 0.8)"/>

        <Footer
                title="Za profilno sliko je lahko kdorkoli!"
                background="rgb(248, 182, 208)"
                :gif="[ { src: require('../assets/za-profilno-sliko-je-lahko-kdorkoli.mp4'), type: 'video/mp4' }, { src: require('../assets/za-profilno-sliko-je-lahko-kdorkoli.webm'), type: 'video/webm' } ]"/>
    </main>
</template>

<script>
	// @ is an alias to /src
	import Title from '@/components/Title.vue'
	import Background from "../components/Background";

	export default {
		name: 'home',
		props: {
			cookiesAccepted: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			Background,
			Title,
			Facts: () => import('@/components/third-rule-sections/Facts.vue'),
			Risk: () => import('@/components/Risk.vue'),
			Actions: () => import('@/components/third-rule-sections/Actions.vue'),
			Footer: () => import("@/components/Footer.vue"),
			Floater: () => import("@/components/Floater"),
		},
		data() {
			return {
				showFloater: false,
				backgroundImage: require('../assets/tretje-pravilo.jpg'),
				setBackgroundImage: false,
			}
		},
		methods: {
			observeTitle(isVisible) {
				this.showFloater = !isVisible;
			},
		},
        watch: {
			cookiesAccepted: function () {
				this.$emit('updateHead');
            },
        },
        head: {
			script: function () {
				if (this.cookiesAccepted) {
					return [
						{
							type: 'text/javascript',
							src: 'https://www.googletagmanager.com/gtag/js?id=UA-102056350-7',
							async: true,
							body: false,
						},
						{
							type: 'text/javascript',
                            body: false,
							inner: `
                                    window.dataLayer = window.dataLayer || [];
                                    function gtag(){dataLayer.push(arguments);}
                                    gtag('js', new Date());
                                    gtag('config', 'UA-102056350-7');
                                    `,
						},
					]
				}
			}
        },
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.setBackgroundImage = true;
			});
		},
	}
</script>

<style lang="scss">
</style>
